// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611032005/js/" + chunkId + "." + {"44":"00401427","225":"74a87fb3","481":"3346005c","486":"61122f76","770":"e730ee33"}[chunkId] + ".0.5234787051101676.chunk.js";
};